import {
  Routes, Route, Navigate, BrowserRouter as Router
} from "react-router-dom";
// import CustomFooter from "./components/CustomFooter";
import VideographerPortofolio from "./Pages/Videographer";
import NotFoundPage from "./Pages/NotFoundPage";
import MainPage from "./Pages/MainPage";

// preference ; https://p5aholic.me/

function App() {
  return (
    <Router>
      <Routes>
        <Route path="*" element={<Navigate to="notfound" />} />
        <Route path="/notfound" element={<NotFoundPage />} />
        <Route path="/" element={<Navigate to="home" />} />
        <Route path="home" element={<MainPage />} />
        <Route path="video" element={<VideographerPortofolio />} />
      </Routes>
    </Router>
  );
}

export default App;
